// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__TNvs7","disabled":"Icon_disabled__X1E+3","colorAccent":"Icon_colorAccent__oB-Wn"};